var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconLoginDark = function SvgIconLoginDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965",
    transform: "translate(-1046.136 -74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "M11.3,13.827A4.414,4.414,0,1,0,6.885,9.414,4.4,4.4,0,0,0,11.3,13.827Zm0,2.942C7.871,16.77,1,18.491,1,21.919V25.6H21.6V21.919C21.6,18.491,14.726,16.77,11.3,16.77Z",
    transform: "translate(1049.712 73.701)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713",
    transform: "translate(1046.136 74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    transform: "translate(0)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.25,
    fill: "none"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLoginDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_login_dark.410238e4.svg";
export { ForwardRef as ReactComponent };